import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { isEqual, defaults } from "lodash";
import store from "../../../state/store";

// State
import { updateUser } from "../../../state/actions/userActions";

// UI Components
import { Col, Container, Row } from "reactstrap";

import Security from "./Security";

class Password extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: defaults(props.user, {
        current_password: "",
        new_password: "",
        confirm_password: "",
      }),
      selected_view: "security",
    };

    store.subscribe(() => {
      this.setState({
        user: store.getState().user.user,
      });
    });

    this.onChangeUser = this.onChangeUser.bind(this);
    this.onSubmitUser = this.onSubmitUser.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const state = {};
    if (!isEqual(nextProps.match.params.view, prevState.selected_view)) {
      state.selected_view = nextProps.match.params.view;
    }
    if (!isEqual(nextProps.user, prevState.user)) {
      state.user = defaults(nextProps.user, {
        current_password: "",
        new_password: "",
        confirm_password: "",
      });
    }
    return state;
  }

  onChangeUser({ target }) {
    const { user } = this.state;

    user[target.name] = target.value;

    this.setState({ user });
  }

  onSubmitUser() {
    const { user } = this.state;

    this.props.updateUser(user);
  }

  render() {
    const { user, selected_view } = this.state;

    return (
      <Container fluid className="p-0">
        <h1 className="h3 mb-3">Password Reset</h1>

        <Row>
          <Col md="9" xl="10">
            <Security
              selected={selected_view}
              user={user}
              onChange={this.onChangeUser}
              onSubmit={this.onSubmitUser}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

Password.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, { updateUser })(withRouter(Password));
